import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useGetSavOrdersByOrderId(orderId) {
  const { data, error, isLoading, mutate } = useSWR(
    orderId ? `/orders/${orderId}/savOrders` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    savOrders: data || [],
    isLoading,
    error,
    mutate,
  };
}

export default useGetSavOrdersByOrderId;
